import { Grid, IconButton } from "@mui/material";
import {
  AddBox as AddBoxIcon,
  Delete as DeleteIcon,
  Link as LinkIcon,
  LinkOff as LinkOffIcon,
  List as ListIcon,
} from "@mui/icons-material";
import { ICellRendererParams } from "ag-grid-community";
type Props = {
  params: ICellRendererParams;
  linkData: (params: ICellRendererParams) => void;
  unlinkData: (params: ICellRendererParams) => void;
  toggleStatusData: (params: ICellRendererParams) => void;
  showContextMenu: () => void;
};
export const ProcessesButtons = ({
  toggleStatusData,
  params,
  unlinkData,
  linkData,
  showContextMenu,
}: Props) => {
  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className="ag-grid-buttons"
    >
      <Grid
        item
        xs={12}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {params.data.IsActive ? (
          <IconButton
            aria-label="link/unlink"
            title={params.data.HeatName ? "Unlink" : "Link"}
            style={{ cursor: "pointer" }}
            onClick={() => {
              params.data.HeatName
                ? unlinkData(params.data)
                : linkData(params.data);
            }}
          >
            {params.data.HeatName ? (
              <LinkOffIcon
                fontSize="inherit"
                color="primary"
                style={{ cursor: "pointer" }}
              />
            ) : (
              <LinkIcon
                fontSize="inherit"
                color="primary"
                style={{ cursor: "pointer" }}
              />
            )}
          </IconButton>
        ) : null}
        <IconButton
          aria-label="delete-icon"
          title={params.data.IsActive ? "Delete" : "Undelete"}
          style={{ cursor: "pointer" }}
          onClick={() => toggleStatusData(params.data)}
        >
          {params.data.IsActive ? (
            <DeleteIcon
              fontSize="inherit"
              color="secondary"
              style={{ cursor: "pointer" }}
            />
          ) : (
            <AddBoxIcon
              fontSize="inherit"
              color="primary"
              style={{ cursor: "pointer" }}
            />
          )}
        </IconButton>
        <IconButton
          aria-label="Options"
          title="Options"
          style={{ cursor: "pointer" }}
          onClick={showContextMenu}
        >
          <ListIcon
            fontSize="inherit"
            color="primary"
            style={{ cursor: "pointer" }}
          />
        </IconButton>
      </Grid>
    </Grid>
  );
};
